import { render, staticRenderFns } from "./AuthorizedRepresentative.vue?vue&type=template&id=30dcbace&scoped=true"
import script from "./AuthorizedRepresentative.vue?vue&type=script&lang=js"
export * from "./AuthorizedRepresentative.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRepresentative.vue?vue&type=style&index=0&id=30dcbace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dcbace",
  null
  
)

export default component.exports